import React, { useRef, useState } from 'react';
import categoriesData from '../../config/categories.json';
import { useNavigate } from 'react-router-dom';
import { MainCategoryNames } from '../../config/envConfig';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBuilding, faMobile, faChartSimple, faMoneyBill } from '@fortawesome/free-solid-svg-icons';

const CategoriesMod: React.FC = () => {
  const navigate = useNavigate();
  const subcategoriesRef = useRef<HTMLDivElement | null>(null);
  const subundercategoriesRef = useRef<HTMLDivElement | null>(null);
  const [selectedMainCategoryId, setSelectedMainCategoryId] = useState<number | null>(null);
  const [selectedSubcategoryId, setSelectedSubcategoryId] = useState<number | null>(null);
  const [forceShowSubUnderCategories, setForceShowSubUnderCategories] = useState<boolean>(false);

  const mainCategories = categoriesData;

  const subcategories = selectedMainCategoryId
    ? mainCategories.find(mc => mc.id === selectedMainCategoryId)?.subcategories || []
    : [];

  const subUnderCategories = (() => {
    if (forceShowSubUnderCategories && selectedMainCategoryId) {
      const servicesCategory = mainCategories.find(mc => mc.id === selectedMainCategoryId);
      const allSubUnderCategories = servicesCategory?.subcategories.flatMap(sc => sc.subUnderCategories) || [];
      return allSubUnderCategories;
    }

    if (selectedSubcategoryId) {
      return subcategories.find(sc => sc.id === selectedSubcategoryId)?.subUnderCategories || [];
    }

    return [];
  })();

  const handleMainCategoryClick = (categoryId: number, categoryName: string) => {
    if (categoryName === MainCategoryNames.Startups) {
      navigate('/startups');
      return;
    }

    setSelectedMainCategoryId(categoryId);
    setSelectedSubcategoryId(null);
    setForceShowSubUnderCategories(categoryName === MainCategoryNames.Services);
    const forceShowSubUnderCategories = categoryName === MainCategoryNames.Services

    if (!forceShowSubUnderCategories) {
      setTimeout(() => {
        if (subcategoriesRef.current) {
          const yOffset = -100;
          const y = subcategoriesRef.current.getBoundingClientRect().top + window.pageYOffset + yOffset;

          window.scrollTo({ top: y, behavior: 'smooth' });
        }
      }, 100);
    }
    else {
      setTimeout(() => {
        if (subundercategoriesRef.current) {
          const yOffset = -100;
          const y = subundercategoriesRef.current.getBoundingClientRect().top + window.pageYOffset + yOffset;

          window.scrollTo({ top: y, behavior: 'smooth' });
        }
      }, 100);
    }
  };

  const handleSubCategoryClick = () => {
    setTimeout(() => {
      if (subundercategoriesRef.current) {
        const yOffset = -100;
        const y = subundercategoriesRef.current.getBoundingClientRect().top + window.pageYOffset + yOffset;

        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    }, 100);
  }

  const getMainCategoryIconProp = (categoryName: string) => {
    switch (categoryName) {
      case "Businesses For Sale":
        return faBuilding;
      case "Products":
        return faMobile;
      case "Services":
        return faChartSimple;
      case "Startups":
        return faMoneyBill;
      default:
        return faBuilding;
    }
  }

  return (
    <div className="p-4">
      {/* Main Categories */}
      <div className="flex flex-wrap justify-center gap-4 mb-8">
        {mainCategories.map((category) => (
          <div
            key={category.id}
            className={`flex flex-col w-32 h-32 items-center justify-center rounded-lg p-4 text-white ${selectedMainCategoryId === category.id ? 'bg-green-600' : ''} cursor-pointer`}
            onClick={() => handleMainCategoryClick(category.id, category.name)}
          >
            <div className="flex items-center justify-center bg-white text-primary rounded-full w-16 h-16 mb-2">
              <FontAwesomeIcon
                icon={getMainCategoryIconProp(category.name)}
                className="text-2xl"
              />
            </div>
            <span className={`text-center ${selectedMainCategoryId === category.id ? 'text-white' : 'text-black'} cursor-pointer`}>{category.name}</span>
          </div>
        ))}
      </div>

      {/* Subcategories */}
      {!forceShowSubUnderCategories && selectedMainCategoryId && (
        <div ref={subcategoriesRef} className="flex flex-wrap gap-4 mb-8">
          {subcategories.map((subcategory) => (
            <div
              key={subcategory.id}
              className={`rounded-lg p-1 bg-gray-200 text-gray-800 ${selectedSubcategoryId === subcategory.id ? 'bg-green-600 text-white' : ''} cursor-pointer `}
              onClick={() => {
                setSelectedSubcategoryId(subcategory.id);
                handleSubCategoryClick();
              }}>
              <span>{subcategory.name}</span>
            </div>
          ))}
        </div>
      )}

      {/* SubUnderCategories */}
      {subUnderCategories.length > 0 && (
        <div ref={subundercategoriesRef} className="flex flex-wrap gap-4 border-t border-gray-300 pt-4">
          {subUnderCategories.map((subUnder) => (
            <div
              key={subUnder.id}
              className="rounded-lg p-1 bg-gray-200 text-gray-800"
            >
              {/* No Icon for SubUnderCategories */}
              <span>{subUnder.name}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CategoriesMod;